import "./Page404.css";

function Page404(): JSX.Element {
  return (
    <div className="Page404">
      <h1>Page not found!</h1>
    </div>
  );
}

export default Page404;
